import React, { useState, useEffect } from "react";
import { Avatar, Box, Icons, Tooltip } from "fds";
import "./index.scss";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Workgroup } from "../../types/workgroup";
import { Route, Routes, useNavigate } from "react-router-dom";
import ClientWorkgorup from "./Page/ClientWorkgroup";
import ClientBookmark from "./Page/ClientBookmark";
import utilsCommon from "../../shared/utils/common";
import ClientSearch from "./Page/ClientSearch";
import dayjs from "dayjs";
import WorkgroupAvatar from "../../components/WorkgroupAvatar";
import ClientMyBox from "./Page/ClientMyBox";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import { t } from "i18next";

const ClientEco = () => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);

  const navigate = useNavigate();
  const { checkMyBoxFileExist } = useDocumentStore();
  const { workgroupState, getWorkgroupSideList } = useWorkgroupStore();
  const [workgroupList, changeWorkgroupList] = useState<Workgroup[]>();
  const [focusedWorkgroupId, changeFocusedWorkgroupId] = useState<
    string | undefined
  >(undefined);
  useEffect(() => {
    const checkFilesExist = async () => {
      const myBoxFiles: any = await checkMyBoxFileExist();
      let workgroupList: any;
      if (loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE")
        workgroupList = await getWorkgroupSideList({
          isDetail: "Y",
          managerId: "",
          orderBy: "workgroupName",
          orderByType: "ASC",
          pageRange: 1,
          posPage: 1,
          rowRange: 0,
          searchDate: { start: 0, end: 0 },
          status: 1,
          workgroupName: "",
        });
      const validCount =
        myBoxFiles?.payload?.map((item: any) => item.total) +
        (loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
          ? 0
          : workgroupList.payload.workgroupList?.filter(
              (item: Workgroup) => item.isValidate === 1
            ).length);

      if (validCount === 0) {
        navigate(`${process.env.PUBLIC_URL}/client/none`);
      }
    };
    checkFilesExist();
  }, []);
  useEffect(() => {
    if (focusedWorkgroupId) {
      navigate(
        `${process.env.PUBLIC_URL}/client/workgroup/${focusedWorkgroupId}`
      );
      if (utilsCommon.isClientLogin("MAC")) {
        (window as any)?.webkit?.messageHandlers.unMarkFavorite.postMessage("");
      } else if (utilsCommon.isClientLogin("WINDOWS")) {
        window?.chrome?.webview?.hostObjects.client.unMarkFavorite();
      }
    }
  }, [focusedWorkgroupId]);
  useEffect(() => {
    if (workgroupState.workgroupSidemenuList === undefined) return;
    let sorted_workgroup = workgroupState.workgroupSidemenuList
      ?.filter(
        (item: Workgroup) =>
          (item.endDate === -1 || item.endDate > dayjs().valueOf()) &&
          item.workgroupJoined
      )
      .slice()
      .sort((a: Workgroup, b: Workgroup) => {
        if (a.favorite === "Y" && b.favorite !== "Y") return -1;
        if (a.favorite !== "Y" && b.favorite === "Y") return 1;
        return 0; // 원래 순서 유지
      });

    changeWorkgroupList(sorted_workgroup);
    if (window.location.href.includes("/workgroup") && !focusedWorkgroupId) {
      if (
        loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE" ||
        sorted_workgroup?.length === 0
      ) {
        navigate(`${process.env.PUBLIC_URL}/client/myBox`);
      } else if (window.location.href.includes("/client/workgroup/")) {
        const newWorkgroupId =
          window.location.href.split("/")[
            window.location.href.split("/").length - 1
          ];
        changeFocusedWorkgroupId(
          sorted_workgroup
            ?.map((item: any) => item.workgroupId)
            .includes(newWorkgroupId)
            ? newWorkgroupId
            : sorted_workgroup[0]?.workgroupId
        );
      } else {
        changeFocusedWorkgroupId(sorted_workgroup[0]?.workgroupId);
      }
    }
  }, [workgroupState.workgroupSidemenuList]);
  return (
    <Box classes="clientEco">
      <Box classes="clientEco-sidemenu overflow-scroll">
        <Tooltip message={"My Box"} place="right" classes="mg mb-16">
          <Box
            classes="clientEco-workgroup"
            onClick={() => {
              navigate(`${process.env.PUBLIC_URL}/client/myBox`);
              changeFocusedWorkgroupId(undefined);
            }}
          >
            {window.location.href.endsWith("/client/myBox") && (
              <Box classes="clicked" />
            )}
            <Avatar
              uniqueCode={"NONEWORKGROUP"}
              shape="workgroup"
              icon={"user"}
              color="gray"
            />
          </Box>
        </Tooltip>
        <Tooltip message={t("bookmark.title")} place="right" classes="mg mb-16">
          <Box
            classes="clientEco-workgroup"
            onClick={() => {
              navigate(`${process.env.PUBLIC_URL}/client/storage`);
              changeFocusedWorkgroupId(undefined);
            }}
          >
            {window.location.href.endsWith("/client/storage") && (
              <Box classes="clicked" />
            )}
            <Avatar
              uniqueCode={"NONEWORKGROUP"}
              shape="workgroup"
              icon="star"
              color="yellow_orange"
            />
          </Box>
        </Tooltip>
        {workgroupList && workgroupList?.length > 0 && (
          <Box classes="clientEco-divider" />
        )}
        {workgroupList?.map((item: Workgroup) => (
          <Tooltip
            message={item.workgroupName}
            place="right"
            classes="mg mb-16"
          >
            <Box
              classes="clientEco-workgroup"
              onClick={() => changeFocusedWorkgroupId(item?.workgroupId)}
            >
              {focusedWorkgroupId === item.workgroupId && (
                <Box classes="clicked" />
              )}
              <WorkgroupAvatar item={item} />
            </Box>
          </Tooltip>
        ))}
      </Box>
      <Routes>
        <Route path={`/workgroup/:workgroupId`} element={<ClientWorkgorup />} />
        <Route path={`/myBox`} element={<ClientMyBox />} />
        <Route path={`/storage`} element={<ClientBookmark />} />
        <Route path={`/search`} element={<ClientSearch />} />
      </Routes>
    </Box>
  );
};

export default ClientEco;
